<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-justify">
          Su solicitud ha sido recepcionada por parte del Servicio Electoral de
          Chile y fue derivada a la Subdirección de Partidos Políticos para su
          análisis y procesamiento (plazo máximo 5 días hábiles a contar del día
          siguiente de su presentación en línea). El resultado de vuestro
          requerimiento de renuncia de afiliación política será notificado al
          correo electrónico registrado en vuestra solicitud. Sin perjuicio de
          lo anterior, su renuncia se registrará, para todos los efectos, a
          partir de la fecha de la presentación de la misma.
        </p>
      </div>
    </div>
    <el-divider></el-divider>
    <template v-if="media.sm">
      <div class="row text-center">
        <div class="col">
          <el-button
            type="success"
            @click="endProcess"
            class="terminar"
            data-cy="resignation-end"
          >
            Terminar
          </el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-end">
        <el-button
          type="success"
          @click="endProcess"
          class="terminar"
          data-cy="resignation-end"
        >
          Terminar
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import { RouterMixin } from "@/mixins/routerMixin";
import { Divider } from "element-ui";

export default {
  name: "RenunciaExitosa",
  components: {
    [Divider.name]: Divider,
  },
  mixins: [ScreenSizeMixin, RouterMixin],
  methods: {
    endProcess() {
      this.navigate({ name: "resumen-tramites" });
    },
  },
};
</script>
